import { getShellLogger } from '../../common/logger'
import { getEventBus } from '../namespaces/event-bus'
import { NotificationChannelEvents, NotificationChannelNamespace } from '../notification-channel'
import type { NotificationChannelEvent, NotificationChannelInfo, RTCError } from '../notification-channel/models'
import type { NotificationHandler } from './notification-handler'
import { NotificationHandlerEventType } from './notification-handler-event'
import { WebSocketNotificationHandler } from './websocket-notification-handler'

export class ShellWebSocketNotificationHandlerFactory {
  private readonly notificationNamespace = getEventBus().register(
    NotificationChannelNamespace,
    NotificationChannelEvents,
  )

  public create = (channelInfo: NotificationChannelInfo): NotificationHandler => {
    const handler = new WebSocketNotificationHandler(channelInfo)
    this.addListeners(handler)
    return handler
  }

  private addListeners = (handler: NotificationHandler): void => {
    handler.addListener(NotificationHandlerEventType.OPEN, this.handleHandlerOpenEvent)
    handler.addListener(NotificationHandlerEventType.CLOSE, this.handleHandlerCloseEvent)
    handler.addListener(NotificationHandlerEventType.MESSAGE, this.handleHandlerMessageEvent)
    handler.addListener(NotificationHandlerEventType.ERROR, this.handleHandlerErrorEvent)
  }

  private handleHandlerOpenEvent = (): void => {
    this.notificationNamespace.emit.connected()
  }

  private handleHandlerCloseEvent = (error: RTCError): void => {
    this.notificationNamespace.emit.disconnected(error)
    getShellLogger().error(error)
  }

  private handleHandlerMessageEvent = (event: NotificationChannelEvent): void => {
    this.notificationNamespace.emit.message(event)
  }

  private handleHandlerErrorEvent = (error: RTCError): void => {
    getShellLogger().error('WebSocket:Error', error)
    this.notificationNamespace.emit.error(error)
  }
}
